/**
 * @file  routes/config.ts
 * @description  defines the route to component mappings
 * @author ogarcia (ozkary)
 *
 */

/**
 * @description add each route to component mappig below.
 */
const routes = [
  {
    path: ['/', '/login', '/home', '/coverage'],
    exact: true,
    component: 'Home'
  },
  {
    path: ['/customer'],
    exact: true,
    component: 'Customer'
  },
  {
    path: ['/payment'],
    exact: true,
    component: 'Payment'
  },
  {
    path: ['/review'],
    exact: true,
    component: 'Review'
  },
  {
    path: ['/checkout'],
    exact: true,
    component: 'Checkout'
  },
  {
    path: ['/receipt'],
    exact: true,
    component: 'Receipt'
  },
  {
    path: ['/end'],
    exact: true,
    component: 'End'
  },
  {
    path: '',
    exact: false,
    component: 'NotFound'
  }
];

// export the route mapping
export default routes;
